<adaa-data-table
    #adaaDataTable
    apiPrefix="forecasted-values"
    apiName="getAll"
    [titleHeader]="('forecasted_values.title_plural' | translate) + ' - ' + ('breadcrumbs.kpi' | translate)"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.FORECASTED_VALUES_CONF_LIST"
    [enableAdd]="false"
    [enableDeleteAction]="false"
    [enableViewAction]="false"
    (actionClicked)="actionClicked($event)"
/>
